import { Colors, Heading, ICON_STROKE_WIDTHS, Icon } from '@amelio/ui-library';

import type { ReactNode } from 'react';

type CascadeModalHeaderProps = {
    isDelete: boolean;
    title: ReactNode;
    dataTestId: string;
};

export const CascadeModalHeader = ({ isDelete, title, dataTestId }: CascadeModalHeaderProps) => (
    <Heading level={4}>
        <span
            className={'text-body-lg flex items-center gap-2'}
            data-testid={dataTestId}
        >
            <span className={'flex h-[1lh] shrink-0 items-center'}>
                <Icon
                    name={isDelete ? 'essential-danger' : 'electronics-power-off'}
                    size={'md'}
                    color={isDelete ? undefined : Colors.BASE_400}
                    strokeWidth={ICON_STROKE_WIDTHS.bold}
                    className={isDelete ? '!text-red-500' : ''}
                    dataTestId={'cascade-modal-header-icon'}
                />
            </span>

            <span className={isDelete ? '!text-red-500' : 'text-navy'}>{title}</span>
        </span>
    </Heading>
);
